import React from "react";
import Home from "./components/Home/home.jsx";
import PublicationsPage from "./components/Publications/publicationsPage";
import EducationalBackgroundPage from "./components/HonorsAndProfessionalBackground/education-honors";
import TeachingEngagementPage from "./components/TeachingEngagements/teaching";
import TeammatesAndCollaborationsPage from "./components/Teammates&Collaborations/teamAndCollab.jsx";
import ResearchProjectsPage from "./components/ResearchProjects/researchProjects";
import ContactPage from "./components/Contact/contact";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

const Portfolio = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/publications",
      element: <PublicationsPage />,
    },
    {
      path: "/honors&ProfessionalBackground",
      element: <EducationalBackgroundPage />,
    },
    {
      path: "/teachingEngagement",
      element: <TeachingEngagementPage />,
    },
    {
      path: "/teammates&collaborations",
      element: <TeammatesAndCollaborationsPage />,
    },
    {
      path: "/researchProjects",
      element: <ResearchProjectsPage />,
    },
    {
      path: "/contact",
      element: <ContactPage />,
    },
  ]);
  return <RouterProvider router={router} />;
};

export default Portfolio;
